module.exports = {
	"de": {
		"title": "Produkte",
		"products": {
			"tarot3d": {
				"title": "Tarot3d",
				"description": ""
			},
			"hallofrunes": {
				"title": "Die Halle der Runen-Karten",
				"description": ""
			},
			"dailyrunes": {
				"title": "Tagesrune",
				"description": "Beschreibung"
			}
		}
	},
	"en": {
		"title": "Products",
		"products": {
			"tarot3d": {
				"title": "Tarot3d",
				"description": "This is Tarot3d"
			},
			"hallofrunes": {
				"title": "Hall of Runes",
				"description": "This is Hall of Runes"
			},
			"dailyrunes": {
				"title": "Daily Rune",
				"description": "This is Daily Rune"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/home-view/locales.json
// module id = 64
// module chunks = 0